import styled from "styled-components";

export const LargeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 0;
  font-family: ${props => props.theme.fontFamilies.paragraph} !important;
  width: 100%;
  @media (max-width: 500px) {
    flex-direction: column;
    flex-grow: 1;
  }
`;

export const Split = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  font-family: ${props => props.theme.fontFamilies.paragraph} !important;

  & > * {
    flex-grow: 1;
    width: 50%;

    @media (max-width: 672px) {
      width: 100%;
    }
  }

  @media (max-width: 672px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: ${props => props.theme.fontSizes.sm};
  align-items: flex-start;
`;

export const Subtitle = styled.div`
  color: ${props => props.theme.ui.colors.primary700};
  font-weight: ${props => props.theme.fontWeights.bold};
  line-height: 16.8px;
  font-family: ${props => props.theme.fontFamilies.paragraph} !important;
  font-weight: 700;
  color: ${props => props.theme.ui.colors.primary700};
`;

export const SubtitleDescription = styled.div`
  color: ${props => props.theme.ui.colors.gray600};
  font-weight: ${props => props.theme.fontWeights.default};
  line-height: 20px;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  font-size: ${props => props.theme.fontSizes.sm};
  min-height: 256px;
  flex: 1;
  min-width: 0;

  & .badge {
    line-height: 20px;
    font-size: 14px;
    font-family: ${props => props.theme.fontFamilies.paragraph} !important;
    font-weight: 400;
    color: ${props => props.theme.ui.colors.primary700};
  }

  @media (max-width: 672px) {
    gap: 20px;
    min-height: 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 700;
  line-height: 24px;
  color: ${props => props.theme.ui.colors.primary700};

  @media (max-width: 768px) {
    & .badge {
      margin-bottom: -6px;
    }
  }
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-family: ${props => props.theme.fontFamilies.paragraph} !important;
`;
